// DON'T EDIT BY HANDS, this page generated was generated by script
// To generate run yarn generate-pages

export const ABOUT_US_PAGE = { name: 'about-us' };

export const CAREERS_PAGE = { name: 'careers' };

export const CONTENT_LOBBY_PAGE = { name: 'content-lobby' };

export const CYPRESS_PAGE = { name: 'cypress' };

// we need this to clear cache with 301 redirect
export const FIX_PAGE = { name: 'fix' };

// index page. Redirect to war room posts if user loggedIn
export const INDEX_PAGE = { name: 'index' };

export const LOGIN_EXTERNAL_PAGE = { name: 'login-external' };

// using for devops purposes
export const PING_PAGE = { name: 'ping' };

export const REDIRECT_PAGE = { name: 'redirect' };

export const REQUEST_TESTIMONIALS_PAGE = { name: 'request-testimonials' };

export const SALES_COMPENSATION_2022_PAGE = { name: 'sales-compensation-2022' };

export const SALES_DIRECTORY_PAGE = { name: 'sales-directory' };

// only for admins. Throw errors to sentry and some other stuff
export const TESTING_PAGE = { name: 'testing' };

// ----------- academy -----------
export const ACADEMY_PAGE = { name: 'academy' };

// edit academy articles only by admins
export const ACADEMY_ARTICLESLUG_EDIT_PAGE = { name: 'academy-articleSlug-edit' };

// academy article page with signup wall for guests
export const ACADEMY_ARTICLESLUG_PAGE = { name: 'academy-articleSlug' };

export const ACADEMY_CATEGORY_CATEGORY_PAGE = { name: 'academy-category-category' };

export const ACADEMY_CATEGORY_PAGE = { name: 'academy-category' };

// ----------- assets -----------
// ----------- connections -----------
export const CONNECTIONS_STEPSLUG_PAGE = { name: 'connections-stepSlug' };

export const CONNECTIONS_PAGE = { name: 'connections' };

// ----------- control-panel -----------
// control panel to manage blocked users only for admins
export const CONTROL_PANEL_PARSERS_PAGE = { name: 'control-panel-parsers' };

// ----------- flex-challenge -----------
export const FLEX_CHALLENGE_STEPSLUG_PAGE = { name: 'flex-challenge-stepSlug' };

export const FLEX_CHALLENGE_PAGE = { name: 'flex-challenge' };

// ----------- jobs -----------
export const JOBS_ABOUT_PAGE = { name: 'jobs-about' };

export const JOBS_PAGE = { name: 'jobs' };

export const JOBS_MATCHING_PAGE = { name: 'jobs-matching' };

export const JOBS_MY_MATCHES_PAGE = { name: 'jobs-my-matches' };

export const JOBS_WELCOME_PAGE = { name: 'jobs-welcome' };

// jobs onboarding index page. If there is last seen step redirect to it. Or redirect to first step. Only for users
export const JOBS_ONBOARDING_PAGE = { name: 'jobs-onboarding' };

// jobs onboarding step page. In case step param is not valid redirect to jobs onboarding index page. Only for users
export const JOBS_ONBOARDING_STEPSLUG_PAGE = { name: 'jobs-onboarding-stepSlug' };

export const JOBS_OPPORTUNITIES_OPPORTUNITYSLUG_PAGE = { name: 'jobs-opportunities-opportunitySlug' };

export const JOBS_PROFILE_PAGE = { name: 'jobs-profile' };

export const JOBS_PROFILE_UPDATE_PAGE = { name: 'jobs-profile-update' };

export const JOBS_VACANCIES_VACANCYSLUG_PAGE = { name: 'jobs-vacancies-vacancySlug' };

// ----------- landing -----------
export const LANDING_ALL_PAGE = { name: 'landing-all' };

// ----------- onboarding-v3 -----------
export const ONBOARDING_V3_STEPSLUG_PAGE = { name: 'onboarding-v3-stepSlug' };

// onboarding-v3 index page. Only for users
export const ONBOARDING_V3_PAGE = { name: 'onboarding-v3' };

// ----------- performance-index -----------
// only for users. Redirect to onboarding page if not finished
export const PERFORMANCE_INDEX_PAGE = { name: 'performance-index' };

// only for users. Redirect to index page if finished
export const PERFORMANCE_INDEX_ONBOARDING_PAGE = { name: 'performance-index-onboarding' };

// only for users
export const PERFORMANCE_INDEX_DEALS_DEALID_PAGE = { name: 'performance-index-deals-dealId' };

// only for users
export const PERFORMANCE_INDEX_DEALS_ADD_MULTIPLE_PAGE = { name: 'performance-index-deals-add-multiple' };

// only for users
export const PERFORMANCE_INDEX_QUARTERS_QUARTERKEY_PAGE = { name: 'performance-index-quarters-quarterKey' };

// ----------- portfolio -----------
export const PORTFOLIO_PAGE = { name: 'portfolio' };

export const PORTFOLIO_TESTIFY_PAGE = { name: 'portfolio-testify' };

export const PORTFOLIO_SLUG_CONNECTIONS_PAGE = { name: 'portfolio-slug-connections' };

export const PORTFOLIO_SLUG_PAGE = { name: 'portfolio-slug' };

export const PORTFOLIO_SLUG_PREVIEW_PAGE = { name: 'portfolio-slug-preview' };

export const PORTFOLIO_SLUG_TESTIFY_PAGE = { name: 'portfolio-slug-testify' };

// ----------- profile -----------
// settings index page. Redirect to settings account page
export const PROFILE_SETTINGS_PAGE = { name: 'profile-settings' };

export const PROFILE_SETTINGS_ACCOUNT_PAGE = { name: 'profile-settings-account' };

export const PROFILE_SETTINGS_APPEARANCE_PAGE = { name: 'profile-settings-appearance' };

export const PROFILE_SETTINGS_NOTIFICATIONS_PAGE = { name: 'profile-settings-notifications' };

// ----------- referral -----------
export const REFERRAL_PRE_ONBOARDING_PAGE = { name: 'referral-pre-onboarding' };

export const REFERRAL_PROMOTION_PAGE = { name: 'referral-promotion' };

// ----------- review -----------
export const REVIEW_STEP_PAGE = { name: 'review-step' };

// ----------- universities -----------
export const UNIVERSITIES_UNIVERSITYSLUG_PAGE = { name: 'universities-universitySlug' };

// ----------- wait-list -----------
export const WAIT_LIST_SKWSLUG_COMPLETE_PAGE = { name: 'wait-list-skwSlug-complete' };

export const WAIT_LIST_SKWSLUG_PAGE = { name: 'wait-list-skwSlug' };

// ----------- war-room -----------
// war room products page. Only for users
export const WAR_ROOM_PRODUCTS_PAGE = { name: 'war-room-products' };

export const WAR_ROOM_CATEGORIES_POSTS_PAGE = { name: 'war-room-categories-posts' };

export const WAR_ROOM_CATEGORIES_CATEGORYSLUG_POSTS_PAGE = { name: 'war-room-categories-categorySlug-posts' };

export const WAR_ROOM_POSTS_POSTSLUG_PAGE = { name: 'war-room-posts-postSlug' };

export const WAR_ROOM_POSTS_PAGE = { name: 'war-room-posts' };

// create new post page. Only for users.
export const WAR_ROOM_POSTS_NEW_PAGE = { name: 'war-room-posts-new' };

export const WAR_ROOM_POSTS_POSTSLUG_COMMENTS_COMMENTID_PAGE = { name: 'war-room-posts-postSlug-comments-commentId' };

// edit post page. Only for users
export const WAR_ROOM_POSTS_EDIT_POSTSLUG_PAGE = { name: 'war-room-posts-edit-postSlug' };

export const WAR_ROOM_POSTS_TAB_TAB_PAGE = { name: 'war-room-posts-tab-tab' };

export const WAR_ROOM_POSTS_TAB_PAGE = { name: 'war-room-posts-tab' };

export const WAR_ROOM_PROFILE_EDIT_PAGE = { name: 'war-room-profile-edit' };

export const WAR_ROOM_PROFILE_USERNAME_BADGES_PAGE = { name: 'war-room-profile-username-badges' };

export const WAR_ROOM_PROFILE_USERNAME_PAGE = { name: 'war-room-profile-username' };

export const WAR_ROOM_TOPICS_TOPICSLUG_POSTS_PAGE = { name: 'war-room-topics-topicSlug-posts' };
